import React from 'react'
import moment from 'moment'

import 'react-big-calendar/lib/sass/styles.scss'
import './App.css';
import WithAuth from './containers/withAuth'
import VacationSheet from './containers/vacationSheet'
function App(props) {
  return (
    <div style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
      <VacationSheet {...props} />
    </div>
  );
}

export default WithAuth(App);